var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { addBGMEventListener } from "../utils";
import { Sound } from "./base";
import { FadeUtils, safePlayAudio } from "./utils";
/**
 * 音乐
 */
var Music = /** @class */ (function (_super) {
    __extends(Music, _super);
    function Music(opts) {
        var _a, _b, _c, _d;
        var _this = _super.call(this) || this;
        /**
         * 是否正在播放
         * (若开启了 fade，音频实际状态可能略微延后)
         */
        _this._isPlay = false;
        /**
         * 是否曾经播放过
         */
        _this._touched = false;
        /**
         * 一些回调监听
         */
        _this._listener = [];
        /**
         * 是否在后台
         */
        _this._isSuspend = false;
        _this._isPlayWhenLeave = false;
        /**
         * 是否暂停了播放
         */
        _this._isPausePlaying = false;
        var audioElem = document.createElement("audio");
        _this._audioElem = audioElem;
        _this._volume = (_a = opts.volume) !== null && _a !== void 0 ? _a : 0.5;
        _this.fade = (_b = opts.fade) !== null && _b !== void 0 ? _b : false;
        _this.fadeDuration = (_c = opts.fadeDuration) !== null && _c !== void 0 ? _c : 1000;
        audioElem.src = opts.src;
        audioElem.crossOrigin = "anonymous";
        audioElem.volume = _this._volume;
        audioElem.loop = (_d = opts.loop) !== null && _d !== void 0 ? _d : false;
        audioElem.load();
        _this.fadeUtil = new FadeUtils();
        if (opts.autoPlay) {
            _this.play();
            // 处理非交互无法播放的情况
            // 通过 user activation 触发播放，chrome 推荐使用 click 事件
            // https://developer.chrome.com/blog/autoplay?hl=zh-cn
            // https://github.com/whatwg/html/issues/3849
            var playWhenInteraction_1 = function () {
                _this.play();
                window === null || window === void 0 ? void 0 : window.removeEventListener("click", playWhenInteraction_1);
            };
            window === null || window === void 0 ? void 0 : window.addEventListener("click", playWhenInteraction_1);
        }
        // 处理浏览器页面不活跃
        if (opts.suspendWhenHidden) {
            document.addEventListener("visibilitychange", function () {
                if (document.hidden) {
                    _this.exit();
                }
                else {
                    _this.enter();
                }
            });
        }
        // 处理森空岛后台情况
        if (opts.suspendWhenHiddenInSkland) {
            // https://hypergryph.feishu.cn/wiki/KmSIw3gY4ilqo9kQnWWc8WIanXc
            import("@skland/one-bridge").then(function (module) {
                var Bridge = module.default;
                if (!Bridge.getSystemInfo().isApp) {
                    return;
                }
                Bridge.onLifecycle("pageDidAppear", _this.enter.bind(_this));
                Bridge.onLifecycle("appWillEnterForeground", _this.enter.bind(_this));
                Bridge.onLifecycle("pageDidDisappear", _this.exit.bind(_this));
                Bridge.onLifecycle("appDidEnterBackground", _this.exit.bind(_this));
            });
        }
        // 视频播放的时候暂停
        addBGMEventListener(function (e) {
            var _a;
            var type = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.type;
            if (type === "PAUSE") {
                _this.pause();
            }
            else if (type === "RESUME") {
                _this.resume();
            }
        });
        return _this;
    }
    Music.prototype.enter = function () {
        if (this._isSuspend === false) {
            return;
        }
        this._isSuspend = false;
        if (this._isPlayWhenLeave) {
            this.resume();
        }
    };
    Music.prototype.exit = function () {
        if (this._isSuspend) {
            return;
        }
        this._isSuspend = true;
        if (this.isPlaying) {
            this._isPlayWhenLeave = true;
            var fadeBackup = this.fade;
            this.fade = false;
            // pause 的时候不能有 fade，否则在手机上会暂停失败
            this.pause();
            this.fade = fadeBackup;
        }
        else {
            this._isPlayWhenLeave = false;
        }
    };
    Object.defineProperty(Music.prototype, "audioElem", {
        /**
         * 音频元素
         */
        get: function () {
            return this._audioElem;
        },
        enumerable: false,
        configurable: true
    });
    Music.prototype.enable = function () {
        this.isEnable = true;
        if (this._isPausePlaying) {
            this.resume();
            this._isPausePlaying = false;
        }
        else {
            this.play();
        }
    };
    Music.prototype.disable = function () {
        this.isEnable = false;
        if (this._isPlay) {
            this._isPausePlaying = true;
        }
        this.pause();
    };
    Object.defineProperty(Music.prototype, "isPlaying", {
        /**
         * 是否正在播放
         */
        get: function () {
            return this._isPlay;
        },
        enumerable: false,
        configurable: true
    });
    Music.prototype._play = function () {
        var _this = this;
        safePlayAudio(this._audioElem, function (err) {
            console.warn(err);
            // 没播放成功则不能设置这个标记
            _this._isPlay = false;
        });
    };
    Music.prototype._pause = function () {
        this._audioElem.pause();
    };
    /**
     * 播放
     */
    Music.prototype.play = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // console.log("PLAY")
                        // 声音被禁用
                        if (this.isEnable === false) {
                            return [2 /*return*/];
                        }
                        if (this._isPlay) {
                            return [2 /*return*/];
                        }
                        this._isPlay = true;
                        this._touched = true;
                        if (!this.fade) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fadeUtil.fadeIn({
                                audio: this._audioElem,
                                targetVolume: this._volume,
                                duration: this.fadeDuration,
                                onStart: function () { return _this._play(); },
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this._play();
                        _a.label = 3;
                    case 3:
                        this._listener.forEach(function (f) { return f(true); });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 暂停
     */
    Music.prototype.pause = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // console.log("PAUSE")
                        if (this._isPlay === false) {
                            return [2 /*return*/];
                        }
                        this._isPlay = false;
                        if (!this.fade) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fadeUtil.fadeOut({
                                audio: this._audioElem,
                                duration: this.fadeDuration,
                                onEnd: function () {
                                    _this._pause();
                                },
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this._pause();
                        _a.label = 3;
                    case 3:
                        this._listener.forEach(function (f) { return f(false); });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 恢复播放
     */
    Music.prototype.resume = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // console.log("RESUME")
                        if (this._touched === false) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.play()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 切换播放状态
     */
    Music.prototype.toggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._isPlay) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.pause()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.play()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 重置播放进度（会暂停）
     */
    Music.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pause()];
                    case 1:
                        _a.sent();
                        this._audioElem.currentTime = 0;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Music.prototype, "volume", {
        /**
         * 获取音量
         */
        get: function () {
            return this._volume;
        },
        /**
         * 更新音量
         */
        set: function (volume) {
            var vol = Math.max(0, Math.min(volume, 1));
            this._volume = vol;
            this._audioElem.volume = vol;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 注册播放状态绑定的回调
     */
    Music.prototype.onPlayStatusChange = function (fn) {
        var _this = this;
        this._listener.push(fn);
        return function () {
            _this._listener = _this._listener.filter(function (f) { return f !== fn; });
        };
    };
    return Music;
}(Sound));
export { Music };
